import * as React from "react";

function SvgKameleoon(props, ref) {
  return (
    <svg
      id="Kameleoon_svg__Calque_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 106.9 106.9"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Kameleoon_svg__st1{fill:#2ee5ac}"}</style>
      <path
        d="M16 61.4c0 16.2 13.2 29.4 29.4 29.4s29.4-13.2 29.4-29.4S61.7 32 45.5 32 16 45.2 16 61.4zm16.1 0c0-7.4 6-13.4 13.4-13.4s13.4 6 13.4 13.4-6 13.4-13.4 13.4-13.4-6-13.4-13.4z"
        fill="#fe2020"
      />
      <path
        className="Kameleoon_svg__st1"
        d="M45.4 16v16C29.2 32 16 45.2 16 61.4s13.2 29.4 29.4 29.4 29.4-13.2 29.4-29.4h16c0 25.1-20.4 45.4-45.4 45.4S0 86.5 0 61.4 20.4 16 45.4 16zM45.4 16V2.7c0-1.5 1.3-2.8 2.8-2.7 31.7 1.4 57.2 26.9 58.6 58.6.1 1.5-1.2 2.8-2.7 2.8H90.9C90.9 36.3 70.5 16 45.4 16z"
      />
      <path
        d="M45.4 32V16c25.1 0 45.4 20.4 45.4 45.5h-16C74.9 45.2 61.7 32 45.4 32z"
        fill="#6464ff"
      />
      <path
        d="M45.4 74.8c7.4 0 13.4-6 13.4-13.4S52.8 48 45.4 48 32 54 32 61.4s6.1 13.4 13.4 13.4z"
        fill="#0a0a0a"
      />
    </svg>
  );
}

export default React.forwardRef(SvgKameleoon);
